import { computed, Injectable } from '@angular/core';
import { FormSettingsGridItemObject } from '@it2go/types';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import {
    SERVICE_SETTINGS_FORMS_TYPE_DEFAULT,
    SERVICE_SETTINGS_FORMS_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-forms.type';

@Injectable()
export class ServiceSettingsFormsStore extends ComponentStoreV2Factory {

    formsCardSettings = toSignal(globalStore!.select(
        selectServiceSettings(SERVICE_SETTINGS_FORMS_TYPE_KEY, SERVICE_SETTINGS_FORMS_TYPE_DEFAULT),
    ));

    forms = computed<FormSettingsGridItemObject[]>(() => this.data.getFormSettings()?.['items'] || []);
}
